import { Logo, SmallLogo } from '../../assets';

import DarkLightMode from '../DarkLightMode';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import Profile from './Profile';
import { QuestionMarkUrl } from '../../routing';
import React from 'react';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';

interface IHeaderProps {
  onShowHideLeftMenu?: () => void;
}

function Header({ onShowHideLeftMenu }: IHeaderProps) {
  return (
    <header className="header-wrapper d-flex">
      <div className="container-fluid d-flex p-4 align-items-center justify-content-between">
        <div className="d-flex align-items-center justify-content-center">
          {onShowHideLeftMenu ? (
            <FontAwesomeIcon
              className="menu-icon"
              icon={faBars}
              style={{ width: 28, height: 24 }}
              color="#fff"
              onClick={onShowHideLeftMenu}
            />
          ) : null}
          <Link to={{ pathname: '/' }} title="Go to the homepage">
            <img
              className="large-logo"
              src={Logo}
              width="257"
              height="60"
              alt="Côntrol logo"
            />
            <img
              className="small-logo"
              src={SmallLogo}
              width="30"
              height="30"
              alt="Côntrol logo"
            />
          </Link>
        </div>
        <div className="d-flex">
          <DarkLightMode />
          <a
            href={QuestionMarkUrl}
            target="_blank"
            rel="noreferrer"
            className="mx-3">
            <FontAwesomeIcon
              icon={faQuestionCircle}
              style={{ width: 25, height: 25 }}
              color="#fff"
            />
          </a>
          <Profile />
        </div>
      </div>
    </header>
  );
}

export default Header;
